import React from "react";
import Layout from "../components/layout/Layout";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";

export default function Error() {
  const { t } = useTranslation();
  const errorImage = `${blobURL}/illustration_404.svg`;

  return (
    <Layout
      className="d-flex sign-up-email align-items-center"
      hidefooter
      headerColor="secondary"
    >
      <div className="container">
        <div className="welcome-shadow-box">
          <img
            src={errorImage}
            alt="Welcome"
            className="welcome-image"
            loading="lazy"
          />
          <h2>
            <span>{t("Sorry, page not found!")}</span>
          </h2>
          <h3>
            <span>
              {t("Sorry, we couldn’t find the page you’re looking for.")}
            </span>
          </h3>
          <div className="ReactModal__Content">
            <div className="loyalty-info-modal">
              <div>
                <div className="difference-wrapper">
                  <div className="difference-col">
                    <p className="difference-title">
                      <span>
                        {" "}
                        {t(
                          "Perhaps you’ve mistyped the URL? Be sure to check your spelling."
                        )}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
